import React, { Fragment, useState, useEffect } from 'react'
import './AddOrEditInstitution.css';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { addInstitution, getInstitution, updateInstitution, getInstitutions, getInstitutionsCategoriesCreated } from '../../services/http';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import Select, { StylesConfig } from 'react-select';
import question from "../../assets/images/yellow_question.svg"
import Loader from '../Loader/Loader';
import { CDN_BASE_URL } from '../../constants/constants';
import ProcessSpinner from '../ProcessSpinner/ProcessSpinner';



const AddOrEditInstitution = (props) => {

    const { operationType } = props;

    const navigate = useNavigate();

    const id_institution = useParams()

    const [displayLoader, setDisplayLoader] = useState(operationType == "new" ? false : true);
    const [processOngoing, setProcessOngoing] = useState(false)

    const [institution, setInstitution] = useState({ libelle: "", category: { value: "", label: "" }, email: "", telephone: "", zones: [], logo: null });

    const [institutionCategories, setInstitutionCategories] = useState([]);

    const [zones, setZones] = useState([{ value: "", label: "" }]);


    // To populate the breadcrumb and update the sidebar menu
    useEffect(() => {
        let type;
        if (operationType == "new") { type = "Ajout" } else { type = "Modification" }
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Institutions", secondLevelLink: "/institution", thirdLevelText: type, thirdLevelLink: ""
            }
        });
        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("institutions", dispatch)
    }, [])
    useEffect(() => {
        console.log(institution)
    }, [institution]);
    const loadInstitutionData = async () => {
        const resp = await getInstitution(id_institution, states.userToken.access_token)
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data ", resp.data)
            let data_received = resp.data?.institution;
            console.log(data_received)
            const newData = resp.data?.institution?.zones?.map(value => ({
                value: value.id,
                label: value.libelle,

            }))

            setInstitution({ ...institution, libelle: data_received.libelle, category: { value: data_received.category_institution.id, label: data_received.category_institution.libelle }, email: data_received.email, telephone: data_received.telephone, zones: newData, logo: data_received.logo })
            setDisplayLoader(false)
        }

        console.log(institution)

    }

    const loadInstitutionCategories = async () => {
        const resp = await getInstitutionsCategoriesCreated(states.userToken.access_token);
        if (resp.response && resp.response.status !== 200) {
            console.log("data error error again ", resp.response)
        } else {
            console.log("data data ", resp.data)

            const newData2 = resp.data?.categoryInstitutions?.map(value => ({
                value: value.id,
                label: value.libelle,
            }))
            setInstitutionCategories(newData2)

            const newData = resp.data?.zones?.map(value => ({
                value: value.id,
                label: value.libelle,
            }))

            setZones(newData)
            console.log(resp.data[0])

        }

    }

    useEffect(() => {
        loadInstitutionCategories();
        console.log(institutionCategories)
    }, [])

    useEffect(() => {
        if (operationType !== "new") { loadInstitutionData() }
        // console.log(id_institution)
    }, [id_institution])

    const [showErrorLibelle, setShowErrorLibelle] = useState(false)
    const [showErrorEmail, setShowErrorEmail] = useState(false)
    const [showErrorTelephone, setShowErrorTelephone] = useState(false)
    const [showErrorCategory, setShowErrorCategory] = useState(false)
    const [showErrorZones, setShowErrorZones] = useState(false)
    const [showErrorLogo, setShowErrorLogo] = useState(false)

    const [libelleErrorMessage, setLibelleErrorMessage] = useState("")
    const [emailErrorMessage, setEmailErrorMessage] = useState("")
    const [telephoneErrorMessage, setTelephoneErrorMessage] = useState("")
    const [categoryErrorMessage, setCategoryErrorMessage] = useState("")
    const [zonesErrorMessage, setZonesErrorMessage] = useState("")
    const [logoErrorMessage, setLogoErrorMessage] = useState("")

    const [imgData, setImgData] = useState(null);

    const dispatch = useDispatch();


    const states = useSelector((state) => state, shallowEqual);

    const handleChangeLabel = (key, e) => {
        var value = e.currentTarget.value;

        if (key == "libelle") {
            setInstitution({ ...institution, libelle: value });
        }
        if (key == "email") {
            setInstitution({ ...institution, email: value });
        }
        if (key == "telephone") {
            setInstitution({ ...institution, telephone: value });
        }
        if (key == "category") {
            setInstitution({ ...institution, category: { value: value, label: e.label } });
        }
        if (key == "zone") {
            setInstitution({ ...institution, zones: value });
        }
    }


    const handleAddInstitution = async (type) => {
        setProcessOngoing(true)
        console.log("Here is institution to add", institution)
        const reqdata = await addInstitution(institution, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status === 422) {
                setProcessOngoing(false)
                // console.log(reqdata.response?.data.error["email"][0].length)
                if (reqdata.response?.data.error["libelle"] && reqdata.response?.data.error["libelle"][0].length != 0) {
                    var errorMsg1 = reqdata.response?.data.error["libelle"][0];
                    setShowErrorLibelle(true)
                    setLibelleErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error["email"] && reqdata.response?.data.error["email"][0].length !== 0) {
                    var errorMsg2 = reqdata.response?.data.error["email"][0];
                    console.log(errorMsg2)
                    setShowErrorEmail(true)
                    setEmailErrorMessage(errorMsg2)
                }
                if (reqdata.response?.data.error["telephone"] && reqdata.response?.data.error["telephone"][0].length != 0) {
                    var errorMsg3 = reqdata.response?.data.error["telephone"][0];
                    setShowErrorTelephone(true)
                    setTelephoneErrorMessage(errorMsg3)
                }
                if (reqdata.response?.data.error["categoryinstitution_id"] && reqdata.response?.data.error["categoryinstitution_id"][0].length != 0) {
                    var errorMsg3 = reqdata.response?.data.error["categoryinstitution_id"][0];
                    setShowErrorCategory(true)
                    setCategoryErrorMessage(errorMsg3)
                }
                if (reqdata.response?.data.error["zone"] && reqdata.response?.data.error["zone"][0].length != 0) {
                    var errorMsg3 = reqdata.response?.data.error["zone"][0];
                    setShowErrorZones(true)
                    setZonesErrorMessage(errorMsg3)
                }
                if (reqdata.response?.data.error["file"] && reqdata.response?.data.error["file"][0].length != 0) {
                    var errorMsg3 = reqdata.response?.data.error["file"][0];
                    setShowErrorLogo(true)
                    setLogoErrorMessage(errorMsg3)
                }
            } else {
                console.log(reqdata.response?.data.error)
                toast.error(reqdata.response?.data.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            toast.success(`Nouvelle institution ${institution.libelle} ajoutée avec succès !`, {
                position: toast.POSITION.TOP_RIGHT
            });
            setInstitution({ ...institution, libelle: "", email: "", telephone: "", category: { value: "", label: "" }, zones: [], logo: null })

            // var el = document.getElementById('categorie-institution');
            // el.options[el.selectedIndex].innerHTML = "Sélectionner la catégorie";

            let response = await getInstitutions(states.userToken.access_token, 1, "");

            let response_copy = response.data.data.map(obj => ({ ...obj, showDelete: false }))

            dispatch({
                type: "SET",
                key: "institutionList",
                payload: response_copy,
            });
            if(type=="retourner") {navigate("/institution")}


        }

    }

    const handleEditInstitution = async () => {
        setProcessOngoing(true)
        console.log("idInstitution", id_institution)
        console.log("idInstitution", institution.categoryId)

        const reqdata = await updateInstitution(id_institution, institution, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status === 422) {
                setProcessOngoing(false)
                console.log("Errorrr ", reqdata.response)
                if (reqdata.response?.data.error?.libelle) {
                    var errorMsg = reqdata.response?.data.error.libelle[0];
                    console.log(errorMsg)
                    setShowErrorLibelle(true)
                    setLibelleErrorMessage(errorMsg)
                }
                if (reqdata.response?.data.error.email) {
                    console.log("mail error")
                    var errorMsg = reqdata.response?.data.error.email[0];
                    setShowErrorEmail(true)
                    setEmailErrorMessage(errorMsg)
                }
                if (reqdata.response?.data.error?.telephone) {
                    var errorMsg = reqdata.response?.data.error.telephone[0];
                    setShowErrorTelephone(true)
                    setTelephoneErrorMessage(errorMsg)
                }
                if (reqdata.response?.data.error["categoryinstitution_id"] && reqdata.response?.data.error["categoryinstitution_id"][0].length != 0) {
                    var errorMsg3 = reqdata.response?.data.error["categoryinstitution_id"][0];
                    setShowErrorCategory(true)
                    setCategoryErrorMessage(errorMsg3)
                }
                if (reqdata.response?.data.error["zone"] && reqdata.response?.data.error["zone"][0].length != 0) {
                    var errorMsg3 = reqdata.response?.data.error["zone"][0];
                    setShowErrorZones(true)
                    setZonesErrorMessage(errorMsg3)
                }
                if (reqdata.response?.data.error["file"] && reqdata.response?.data.error["file"][0].length != 0) {
                    var errorMsg3 = reqdata.response?.data.error["file"][0];
                    console.log("Errorrrr", errorMsg3)
                    setShowErrorLogo(true)
                    setLogoErrorMessage(errorMsg3)
                }

            } else {
                //    Should redirect to an Error Page
                console.log(reqdata.response?.data.error)
            }
        } else {
            setProcessOngoing(false)
            toast.success(`Modification effectuée !`, {
                position: toast.POSITION.TOP_RIGHT
            });
            navigate("/institution")
        }
    }

    const handleBack = () => {
        navigate("/institution")
    }


    useEffect(() => {
        if (institution.libelle !== "") {
            setShowErrorLibelle(false)
        }
        if (institution.email !== "") {
            setShowErrorEmail(false)
        }
        if (institution.telephone !== "") {
            setShowErrorTelephone(false)
        }
        if (institution.category.value !== "") {
            setShowErrorCategory(false)
        }
        if (institution.zones !== []) {
            setShowErrorZones(false)
        }
        if (institution.logo !== null) {
            setShowErrorLogo(false)
        }
    }, [institution])

    const zoneSelection = (e) => {
        let values = []
        e.map(a => values.push({ value: a.value, label: a.label }));
        // console.log("values", typeof values)
        console.log(values)

        setInstitution({ ...institution, zones: values })
    }

    const categorySelection = (e) => {
        setInstitution({ ...institution, category: { value: e.value, label: e.label } })
    }

    const handleFileChoose = (e) => {
        const value = e.currentTarget.files[0]
        console.log("value ", value)
        setImgData(URL.createObjectURL(e.target.files[0]));
        setInstitution({ ...institution, logo: value })
    }

    const customStyles = {
        control: (provided, state) => ({
          ...provided,
          background: '#fff',
          borderColor: '#9e9e9e',
          minHeight: '35px',
          height: '35px',
          boxShadow: state.isFocused ? null : null,
        }),
    
        valueContainer: (provided, state) => ({
          ...provided,
          height: '35px',
          padding: '0 6px',
          marginTop: '-5px'
        }),
    
        input: (provided, state) => ({
          ...provided,
          margin: '0px',
        }),
        indicatorSeparator: state => ({
          display: 'none',
        //   height: '30px'
        }),
        indicatorsContainer: (provided, state) => ({
          ...provided,
          height: '35px',
        }),
      };

      const customStyles2 = {
        control: (provided, state) => ({
          ...provided,
          background: '#fff',
          borderColor: '#9e9e9e',
          minHeight: '35px',
        //   height: '35px',
          boxShadow: state.isFocused ? null : null,
        }),
    
        valueContainer: (provided, state) => ({
          ...provided,
          minHeight: '35px',
          padding: '0 6px',
        //   marginTop: '-5px'
        }),
    
        input: (provided, state) => ({
          ...provided,
          margin: '0px',
        }),
        indicatorSeparator: state => ({
          display: 'none',
        //   height: '30px'
        }),
        indicatorsContainer: (provided, state) => ({
          ...provided,
          minHeight: '35px',
        }),
      };

    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    <div className="layout-px-spacing">

                        <div className="row layout-top-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div>
                        </div>
                        {displayLoader == false ?
                            <div id='add-edit-institution' className="widget widget-content widget-content-area mt-3">
                                <div className="pl-3 mx-auto">
                                    <h5 className="modal-title py-2 text-left" id="exampleModalLabel">{operationType == "new" ? "Nouvelle Institution" : "Modifier Institution"}</h5>
                                </div>
                                <hr />
                                <div className="w-90 mx-auto">
                                    <div class="form-group row w-80 mx-auto  mb-4 pt-4">
                                        <label for="logo" class="col-sm-4 col-form-label col-form-label-sm required text-dark">Logo</label>
                                        <div class="col-sm-8">
                                            <div className="text-center mb-3">
                                                <div className="custom-file">
                                                    <input type="file"
                                                        onChange={(e) => handleFileChoose(e)}
                                                        className="custom-file-input" id="customFile-institution-logo-Input" />
                                                    {<label class="custom-file-label" id="customFile-institution-logo-Label" for="customFile-institution-logo-Input">
                                                        {/* {(institution.logo != null) ? (institution.logo?.name != undefined ? institution.logo?.name : institution.logo ) :"Aucun fichier"} */}
                                                        {institution.logo != null && <img style={{ border: showErrorLogo == true ? "2px solid red" : "", width: 90, height: 90, marginTop: "-30px", cursor: "pointer" }} src={(institution.logo?.name != undefined ? imgData : `${CDN_BASE_URL}${institution?.logo}`)} />}
                                                        {institution.logo == null && <img style={{ border: showErrorLogo == true ? "2px solid red" : "", width: 90, height: 90, marginTop: "-30px", cursor: "pointer" }} src={(question)} />}
                                                    </label>}
                                                    <br />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                                {showErrorLogo== true && <span className="new-institution-error-span">{logoErrorMessage}</span>}

                                    <div class="form-group row w-80 mx-auto mb-4 pt-3">
                                        <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm required text-dark">Libellé</label>
                                        <div class="col-sm-8">
                                            <input type="text" onChange={(e) => handleChangeLabel("libelle", e)} className={showErrorLibelle == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.libelle} required />
                                            {showErrorLibelle == true && <span className="new-institution-error-span">{libelleErrorMessage}</span>}
                                        </div>
                                    </div>



                                    <div class="form-group row w-80 mx-auto mb-4">
                                        <label for="category" class="col-sm-4 col-form-label col-form-label-sm required text-dark">Catégorie</label>
                                        <div class="col-sm-8">

                                            <Select
                                                onChange={categorySelection}
                                                placeholder=""
                                                className={showErrorCategory == true ? "new-institution-error-input " : ""}
                                                classNamePrefix="select"
                                                value={institution.category.label !== "" ? institution.category : ""}
                                                // value={operationType !== "new" ? categories[1] : ""}
                                                isDisabled={false}
                                                isLoading={false}
                                                isClearable={false}
                                                isRtl={false}
                                                isSearchable={false}
                                                name="institution-category"
                                                options={institutionCategories}
                                                styles={customStyles}
                                            />
                                            {showErrorCategory == true && <span className="new-institution-error-span">{categoryErrorMessage}</span>}
                                        </div>
                                    </div>

                                    <div class="form-group row w-80 mx-auto mb-4">
                                        <label for="email" class="col-sm-4 col-form-label col-form-label-sm required text-dark">Email</label>
                                        <div class="col-sm-8">
                                            <input type="email" onChange={(e) => handleChangeLabel("email", e)} className={showErrorEmail == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "custom-form-control form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.email} required />
                                            {showErrorEmail == true && <span className="new-institution-error-span">{emailErrorMessage}</span>}
                                        </div>
                                    </div>

                                    <div class="form-group row w-80 mx-auto mb-4">
                                        <label for="telephone" class="col-sm-4 col-form-label col-form-label-sm required text-dark truncate" title={"Téléphone(sans indicatif)"}>Téléphone(<span style={{color: "red"}}>sans indicatif</span>)</label>
                                        <div class="col-sm-8">
                                            <input type="tel" onChange={(e) => handleChangeLabel("telephone", e)} className={showErrorTelephone == true ? "form-control custom-form-control form-control-sm new-institution-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={institution.telephone} required />
                                            {showErrorTelephone == true && <span className="new-institution-error-span">{telephoneErrorMessage}</span>}
                                        </div>
                                    </div>

                                    <div class="form-group row w-80 mx-auto mb-4">
                                        <label for="telephone" class="col-sm-4 col-form-label col-form-label-sm required text-dark">Zone(s)</label>
                                        <div class="col-sm-8">

                                            <Select
                                                onChange={zoneSelection}
                                                // value={operationType !== "new" && agent.roles}
                                                value={institution.zones}
                                                placeholder=""
                                                isMulti
                                                name="zones"
                                                options={zones}
                                                // className="basic-multi-select"
                                                className={showErrorZones == true ? "new-institution-error-input " : ""}
                                                classNamePrefix="select"
                                            styles={customStyles2}
                                            />

                                            {showErrorZones == true && <span className="new-institution-error-span">{zonesErrorMessage}</span>}
                                        </div>
                                    </div>
                                </div>
<hr/>
                                <div className="new-institution-custom-modal-footer w-90 pb-3">
                                    
                                    {processOngoing == false ? <Fragment>
                                    <button type="button"
                                        title={operationType == "new" ? "Ajouter et rester sur la page" : "Modifier"}
                                        className="btn btn-primary ml-3" onClick={operationType == "new" ? () => handleAddInstitution("rester") : handleEditInstitution}>{operationType == "new" ? "Ajouter et Nouveau" : "Modifier"}</button>
                                    {operationType == "new" &&
                                        <button type="button"
                                            title={"Ajouter et retourner à la liste"}
                                            className="btn btn-primary ml-3"
                                            onClick={() => handleAddInstitution("retourner")}>
                                            Ajouter et Retourner</button>
                                    }
                                    </Fragment> : <ProcessSpinner />}
                                    <button className=" ml-3 btn" data-dismiss="modal" onClick={handleBack}><i className="flaticon-cancel-12"></i> Retour</button>
                                </div>
                            </div> : <div style={{ marginTop: "25%" }}>
                                <Loader />
                            </div>}
                    </div>

                </div>
            </div>
        </div>



    )
}

export default AddOrEditInstitution

